import styled, { css } from 'styled-components';
import { Message } from '../Styles';

const bidderBgColor = '#53c0ec';
const bidderMemberNameBgColor = '#bceafd';
const globalBgColor = '#1C6C98';
const globalMemberNameBgColor = '#49a7db';

export const StyledMessage = styled(Message)`
  float: left;
  color: #fff;
  width: 78%;
  @media (min-width: 1300px) {
    width: 83%;
  }
  @media (min-width: 1500px) {
    width: 85%;
  }
  @media (min-width: 2000px) {
    width: 90%;
  }
  text-align: right;
  background-color: ${bidderBgColor};
  border-radius: 10px 10px 0 10px;
  &::after {
    content: '';
    position: absolute;
    bottom: -6px;
    border-top: 6px solid ${bidderBgColor};
    right: 0;
    border-left: 7px solid transparent;
  }
`;

export const MessageText = styled.div`
  ${({ isGlobalMessage, zoomLevel }) => css`
    //font-size: ${zoomLevel < 1 ? '1.5em' : '1.2em'};
    /* font-size: ${(props) => (props.zoomLevel < 1 && props.chatFontSize > 0 ? `${1.5 + Number(`.${props.chatFontSize}`)}em` : `1.2em`)}; */
    font-size: ${(props) => (props.zoomLevel < 1 && props.chatFontSize > 0 ? `${1.5 + Number(`.${props.chatFontSize}`)}em` : `${1.2 + Number(`.${props.chatFontSize}`)}em`)};
    display: flex;
    color: ${isGlobalMessage ? '#fff' : '#000'};
    justify-content: space-between;
    align-items: flex-start;
    & div:first-child {
      max-width: 40%;
      text-align: left;
      //font-size:.8em;
      //font-size: ${(props) => (props.chatFontSize > 0 ? `${.8 + Number(`.${props.chatFontSize}`)}em` : '.8em')};
      padding: 2px;
      background-color: ${isGlobalMessage ? globalMemberNameBgColor : bidderMemberNameBgColor};
      border-radius: 3px;
      margin-right: 0px;
    }
    & div:last-child {
      max-width: 60%;
    }
  `}
  `;

export const IndividualMessage = styled(StyledMessage)``;

export const GlobalMessage = styled(StyledMessage)`
  background-color: ${globalBgColor};
  &::after {
    border-top: 6px solid ${globalBgColor};
  }
`;
